import React, { useState } from "react";

import { faFloppyDisk } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { SaveArtifactModal } from "./SaveArtifactModal";

import type { ChatOutput } from "../types";

import { useReportingChatStore } from "../store";

// Small button + modal pair dropped into each output bubble. Once a saved artifact is loaded into
// this session, the same control overwrites it (Update) instead of creating a new one.
export const SaveOutputControl: React.FC<{ output: ChatOutput; defaultName: string }> = ({ output, defaultName }) => {
	const [isOpen, setIsOpen] = useState(false);
	const loadedArtifactId = useReportingChatStore((state) => state.loadedArtifactId);

	return (
		<>
			<button
				type="button"
				onClick={() => setIsOpen(true)}
				className="flex shrink-0 items-center gap-1.5 rounded px-2 py-1 text-xs font-medium text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700"
			>
				<FontAwesomeIcon icon={faFloppyDisk} className="text-[11px]" />
				<span>{loadedArtifactId ? "Update" : "Save"}</span>
			</button>
			<SaveArtifactModal
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				output={output}
				defaultName={defaultName}
			/>
		</>
	);
};

export default SaveOutputControl;
